import type { EsignContractDialogExpose } from '@/components/esign-contract-dialog/index.vue'

// 组件实例引用
let dialogInstance: EsignContractDialogExpose | null = null

/**
 * 设置弹框组件实例
 */
export function setEsignContractDialogInstance(instance: EsignContractDialogExpose | null) {
    dialogInstance = instance
}

/**
 * 检查是否需要显示签署合同弹框
 * @param productType 产品类型
 * @returns Promise<boolean> true表示可以继续，false表示被阻断
 */
export function checkEsignContract(productType: number): Promise<boolean> {
    if (!dialogInstance) {
        console.warn('EsignContractDialog 组件未初始化')
        return Promise.resolve(true)
    }
    return dialogInstance.checkAndShowDialog(productType)
}

/**
 * 静默关闭弹框（不记录到localStorage）
 * 用于路由跳转到不需要弹框的页面时关闭当前弹框
 */
export function closeEsignContractDialogSilently() {
    if (dialogInstance) {
        dialogInstance.closeDialogSilently()
    }
}
